"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _noop2 = _interopRequireDefault(require("lodash-es/noop"));
var _get2 = _interopRequireDefault(require("lodash-es/get"));
var _isEmpty2 = _interopRequireDefault(require("lodash-es/isEmpty"));
var _inputHelper = require("../inputHelper");
var _misc = _interopRequireDefault(require("../../tokens/misc"));
var _excluded = ["onChange"];
/* eslint-disable no-unused-vars */
// libraries
// helpers
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Textarea = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    focused = _useState2[0],
    toggleFocus = _useState2[1];
  var onFocusToggle = function onFocusToggle(_) {
    toggleFocus(!focused);
  };
  var state = (0, _inputHelper.getState)(props, focused);
  var helperTxt = (0, _inputHelper.getHelperText)(props.helperText, props.errorMsg);
  var textAreaProps = {
    resize: props.resize,
    width: props.innerWidth,
    icon: props.icon,
    disabled: props.disabled,
    fullWidth: props.fullWidth,
    rows: props.dynamicHeight ? 1 : props.rows,
    name: props.name,
    dynamicHeight: props.dynamicHeight,
    value: props.value,
    autoFocus: props.autoFocus,
    ref: ref
  };

  // Changes height of textarea through ref. After that, make changes to onChange
  var changeHandler = function changeHandler(e) {
    if (props.dynamicHeight && !(0, _isEmpty2["default"])(ref)) {
      ref.current.style.height = "auto";
      var scrollHeight = (0, _get2["default"])(ref, "current.scrollHeight", 0);
      if (scrollHeight) {
        ref.current.style.height = "".concat(scrollHeight, "px");
      }
    }
    (0, _inputHelper.onValueChange)(props)(e);
  };
  var onChange = props.onChange,
    otherProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Textarea.Wrapper, (0, _extends2["default"])({}, otherProps, {
    onFocus: onFocusToggle,
    onBlur: (0, _inputHelper.onBlurred)(props, onFocusToggle),
    fullWidth: props.fullWidth
  }), /*#__PURE__*/_react["default"].createElement(Textarea.Element, (0, _extends2["default"])({}, textAreaProps, {
    state: state,
    onChange: changeHandler,
    tabIndex: "0"
  })), props.disabled ? /*#__PURE__*/_react["default"].createElement(Textarea.LabelDisabled, {
    showLbl: true,
    state: state
  }, props.label) : /*#__PURE__*/_react["default"].createElement(Textarea.Label, {
    showLbl: focused || !!props.value,
    state: state,
    hideLabel: props.hideLabel,
    value: props.value
  }, props.label), helperTxt && /*#__PURE__*/_react["default"].createElement(Textarea.Helper, {
    state: state
  }, helperTxt));
});
var getResize = function getResize(props) {
  return props.resize;
};
Textarea.Helper = _styledComponents["default"].div.withConfig({
  componentId: "sc-uuxepk-0"
})(["height:13px;color:", ";font-size:11px;line-height:13px;margin-top:5px;"], (0, _inputHelper.getAttributes)("helperColor"));
Textarea.Wrapper = _styledComponents["default"].section.withConfig({
  componentId: "sc-uuxepk-1"
})(["position:relative;width:", ";"], function (props) {
  return props.fullWidth ? "100%" : "auto";
});
Textarea.Label = _styledComponents["default"].label.withConfig({
  componentId: "sc-uuxepk-2"
})(["position:absolute;pointer-events:none;transition:0.2s ease all;color:", ";top:", ";left:", ";font-size:", ";background:", ";padding:", ";display:", ";"], (0, _inputHelper.getAttributes)("placeholder"), (0, _inputHelper.getLabelAttr)("top"), (0, _inputHelper.getLabelAttr)("left"), (0, _inputHelper.getLabelAttr)("fontSize"), (0, _inputHelper.getLabelAttr)("background"), (0, _inputHelper.getLabelAttr)("padding"), (0, _inputHelper.getLabelAttr)("display"));
Textarea.LabelDisabled = _styledComponents["default"].label.withConfig({
  componentId: "sc-uuxepk-3"
})(["position:absolute;pointer-events:none;color:", ";top:", ";left:", ";font-size:", ";background:", ";padding:", ";"], (0, _inputHelper.getAttributes)("placeholder"), (0, _inputHelper.getLabelAttr)("top"), (0, _inputHelper.getLabelAttr)("left"), (0, _inputHelper.getLabelAttr)("fontSize"), (0, _inputHelper.getLabelAttr)("labelBackground"), (0, _inputHelper.getLabelAttr)("padding"));
Textarea.Element = _styledComponents["default"].textarea.withConfig({
  componentId: "sc-uuxepk-4"
})(["padding:", ";background:", ";border:", " ", ";font-size:", ";width:", ";outline:none;&::-webkit-input-placeholder{color:#a9a9a9;}box-sizing:border-box;border-radius:", ";resize:", ";color:", ";overflow:", ";"], (0, _inputHelper.getAttributes)("padding"), (0, _inputHelper.getAttributes)("background"), (0, _inputHelper.getAttributes)("borderWidth"), (0, _inputHelper.getAttributes)("borderColor"), (0, _inputHelper.getAttributes)("fontSize"), (0, _inputHelper.getAttributes)("width"), _misc["default"].radius, getResize, (0, _inputHelper.getAttributes)("text"), function (_ref) {
  var dynamicHeight = _ref.dynamicHeight;
  return dynamicHeight ? "hidden" : "auto";
});
Textarea.propTypes = {
  label: _propTypes["default"].string,
  value: _propTypes["default"].string,
  hideLabel: _propTypes["default"].bool,
  innerWidth: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  rows: _propTypes["default"].number,
  resize: _propTypes["default"].string,
  helperText: _propTypes["default"].string,
  icon: _propTypes["default"].string,
  fullWidth: _propTypes["default"].bool,
  errorMsg: _propTypes["default"].string,
  dynamicHeight: _propTypes["default"].bool,
  autoFocus: _propTypes["default"].bool
};
Textarea.defaultProps = {
  color: "white",
  disabled: false,
  hideLabel: false,
  value: "",
  rows: 2,
  onChange: _noop2["default"],
  onBlur: _noop2["default"],
  helperText: "",
  errorMsg: "",
  dynamicHeight: false,
  autoFocus: false
};
var _default = exports["default"] = Textarea;